import { Sanity$Document } from '../../../types/sanityTypes';
import { logSentryError } from '../../sentry';

export function extractUtmOverridesFromSanity(
  sanityDocument?: Sanity$Document,
) {
  let utmSource: string | undefined;
  let utmCampaign: string | undefined;
  let utmContent: string | undefined;
  let utmMedium: string | undefined;
  let utmTerm: string | undefined;
  let utmId: string | undefined;

  if (!sanityDocument) {
    return { utmSource, utmCampaign, utmContent, utmMedium, utmTerm, utmId };
  }

  // Legacy support for individual fields
  if ('utmSource' in sanityDocument) utmSource = sanityDocument.utmSource;
  if ('utmCampaign' in sanityDocument) utmCampaign = sanityDocument.utmCampaign;
  if ('utmContent' in sanityDocument) utmContent = sanityDocument.utmContent;

  // New JSON-based UTM overrides (takes precedence)
  if ('utmOverrides' in sanityDocument && sanityDocument.utmOverrides?.code) {
    try {
      const overrides = JSON.parse(sanityDocument.utmOverrides.code);

      if (overrides.utm_source !== undefined) utmSource = overrides.utm_source;
      if (overrides.utm_campaign !== undefined)
        utmCampaign = overrides.utm_campaign;
      if (overrides.utm_content !== undefined)
        utmContent = overrides.utm_content;
      if (overrides.utm_medium !== undefined) utmMedium = overrides.utm_medium;
      if (overrides.utm_term !== undefined) utmTerm = overrides.utm_term;
      if (overrides.utm_id !== undefined) utmId = overrides.utm_id;
    } catch (error) {
      logSentryError(error, { utmOverrides: sanityDocument.utmOverrides });
    }
  }

  return { utmSource, utmCampaign, utmContent, utmMedium, utmTerm, utmId };
}
